<script>
  import Infinite from '@/assets/infinite.svg';
  import FinancierCheck from '@/assets/financier-check.svg';
  import FinancierDepositBtc from '@/assets/financier-deposit-btc.svg';
  import FinancierDepositReal from '@/assets/financier-deposit-real.svg';
  import FinancierWithdrawBtc from '@/assets/financier-withdraw-btc.svg';
  import FinancierWithdrawReal from '@/assets/financier-withdraw-real.svg';

  export default {
    components: {
      Infinite,
      FinancierCheck,
      FinancierDepositBtc,
      FinancierDepositReal,
      FinancierWithdrawBtc,
      FinancierWithdrawReal,
    },

    props: {
      title: {
        type: String,
        required: true,
      },

      badge: {
        type: String,
        required: true,
      },

      parent: {
        type: String,
        required: false,
      },

      deposit: {
        type: Object,
        required: false,
        default: () => ({
          //
        }),
      },

      perks: {
        type: Array,
        required: true,
      },

      withdraw: {
        type: Object,
        required: false,
        default: () => ({
          //
        }),
      },

      infos: {
        type: Array,
        required: true,
      },
    },

    computed: {
      hasFilledInfo () {
        return this.infos.find(({ verified }) => verified === false) === undefined;
      },
    },
  };
</script>

<template>
  <section
    class="financier-plan"
    :class="{ 'financier-plan--active': hasFilledInfo }"
    >

    <h1 class="financier-plan__title">
      {{ title }}

      <span
        v-text="badge"
        class="financier-plan__badge"
        >
      </span>
    </h1>

    <p
      style="height: 30px"
      class="financier-plan__parent"
      v-text="parent ? `Todas as vantagens do ${parent}, mais:` : ''"
      >
    </p>

    <ul
      style="height: 94px"
      class="financier-plan__list"
      >
      <li
        :key="perk"
        v-for="perk in perks"
        class="financier-plan__item financier-plan__item--active"
        >
        <FinancierCheck
          class="financier-plan__check"
          />
        {{ perk }}
      </li>
    </ul>

    <h2 class="financier-plan__subtitle">Limite de depósitos</h2>

    <ul class="financier-plan__limits">
      <li class="financier-plan__limit">
        <FinancierDepositBtc class="financier-plan__icon" /> <Infinite class="financier-plan__infinite" v-if="deposit.btc" /> {{ deposit.btc ? 'Ilimitado' :  'Não avaliado' }}
      </li>

      <li class="financier-plan__limit">
        <FinancierDepositReal class="financier-plan__icon" /> {{ deposit.real || 'Não avaliado' }}
      </li>
    </ul>

    <h2 class="financier-plan__subtitle">Limite de saques</h2>

    <ul class="financier-plan__limits financier-plan__limits--margin">
      <li class="financier-plan__limit">
        <FinancierWithdrawBtc class="financier-plan__icon" /> <Infinite class="financier-plan__infinite" v-if="withdraw.btc" /> {{ withdraw.btc ? 'Ilimitado' : 'Não avaliado' }}
      </li>

      <li class="financier-plan__limit">
        <FinancierWithdrawReal class="financier-plan__icon" /> {{ withdraw.real || 'Não avaliado' }}
      </li>
    </ul>

    <h2 class="financier-plan__subtitle">Dados requiredos</h2>

    <ul
      style="height: 68px"
      class="financier-plan__list"
      >
      <li
        :key="label"
        v-for="({ label, verified }) in infos"
        class="financier-plan__item financier-plan__item"
        :class="{ 'financier-plan__item--active': verified }"
        >
        <FinancierCheck
          v-if="verified"
          class="financier-plan__check"
          />
        {{ label }}
      </li>
    </ul>

    <button
      class="financier-plan__action"
      v-text="hasFilledInfo ? 'Verificado' : 'Continuar'"
      :class="{ 'financier-plan__action--active': hasFilledInfo }"
      >
    </button>
  </section>
</template>

<style lang="scss">
  .financier-plan {
    padding: 24px;
    border-radius: 10px;
    border: 1px solid rgba(#FFF, .4);

    &--active {
      border-color: #FFF;
      background-color: #14162f;
    }

    &__title {
      color: #FFF;
      display: flex;
      font-size: 22px;
      font-weight: 300;
      line-height: 1.27;
      margin-bottom: 40px;
    }

    &__badge {
      font-size: 13px;
      padding: 5px 8px;
      font-weight: 400;
      margin-left: 16px;
      border-radius: 4px;
      line-height: normal;
      letter-spacing: .26px;
      color: rgba(#FFF, .8);
      border: 1px solid #FFF;
    }

    &__subtitle {
      line-height: 1;
      color: #b2b8c5;
      margin-bottom: 16px;
      letter-spacing: .32px;
    }

    &__parent {
      font-size: 13px;
      color: #b2b8c5;
      margin-bottom: 16px;
      letter-spacing: .26px;
    }

    &__list {
      margin-bottom: 32px;
    }

    &__item {
      color: #FFF;
      line-height: 1;
      font-size: 14px;
      list-style: disc;
      margin-left: 16px;
      position: relative;
      letter-spacing: .28px;

      &:not(:last-child) {
        margin-bottom: 12px;
      }

      &--active {
        margin-left: 0;
        color: #56ad60;
        padding-left: 25px;
        list-style: none !important;
      }
    }

    &__limits {
      margin-bottom: 16px;

      &--margin {
        margin-bottom: 32px;
      }
    }

    &__limit {
      padding: 10px;
      display: flex;
      line-height: 1;
      font-size: 13px;
      color: #b2b8c5;
      align-items: center;
      border: 1px solid rgba(#6e7793, .4);
      letter-spacing: .26px;

      &:not(:first-child) {
        border-top: 0;
      }
    }

    &__infinite {
      margin-right: 4px;
    }

    &__icon {
      margin-right: 8px;
    }

    &__check {
      top: 0;
      left: 0;
      position: absolute;
    }

    &__action {
      width: 100%;
      color: #FFF;
      padding: 12px;
      margin-top: 16px;
      border-radius: 4px;
      letter-spacing: 0.32px;
      border: 1px solid #ffffff;

      &:hover {
        background-color: rgba(#FFF, 0.1);
      }

      &--active {
        border: none;
        background-color: #3e388b !important;
      }
    }
  }
</style>
